import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M17 6.1H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 12.1H3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15.1 18H3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Text";
const Text = memo(themed(Icon));
export {
  Text
};
//# sourceMappingURL=text.js.map
